module.exports = __webpack_public_path__ + "img/umkm_tokenumkmwax.f5694f7.png";